














import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import activityService, { InsulationModel } from "@/service/activityService";
import moment from "moment";
@Component({
  components: {},
})
export default class Flight extends Vue {
  @Prop({ default: false })
  showDialog!: boolean;

  @Prop()
  depart!: string;
  @Prop()
  arrive!: string;

  get active(): InsulationModel {
    return this.Insulations && this.Insulations[this.activeIndex];
  }
  activeIndex = 0;

  Insulations: InsulationModel[] = [];

  mounted() {
    this.loadData();
  }
  loadData() {
    this.activeIndex = 0;
    let depart = this.depart || this.arrive;
    let arrive = this.arrive || this.depart;

    // activityService.getInsulation(depart, arrive).then(response => {
    //   if (response.isSucc && response.result) {
    //     let Insulations = response.result.filter((o) => o.TripCode == "goto" && o.CityText);
    //     if (depart == arrive && Insulations.length > 0) {
    //       Insulations = [Insulations[Insulations.length - 1]];
    //     }
    //     this.Insulations = Insulations;
    //     if (this.Insulations.length > 0) {
    //       this.showDialog = true;
    //     }
    //   }
    // });
  }

  // @Watch("arrive")
  // arriveCityChange() {
  //   this.loadData();
  // }
  // @Watch("depart")
  // departCityChange() {
  //   this.loadData();
  // }

  confirm() {
    if (this.activeIndex >= this.Insulations.length) {
      this.showDialog = false;
      this.$emit("close", false);
    } else {
      this.activeIndex++;
    }
  }

  formatText(message: string) {
    // return `${message}`;
    return `${message}
      (来源:${moment(new Date()).format("M月D日")}${this.depart || this.arrive}本地宝) <br/><br/> <b style='color:red;'>以上信息供您参考，因疫情传播风险较强，各地疫情防空政策可能随时调整，请您在出行前务必参照当地最新疫情防控规定，合理安排出行。</b> <br/><br/> <span>更新日期：${moment(new Date()).format("M月D日 HH:mm")}</span>`;
  }
}
